import React from 'react';
import ServerError from '../pages/ServerError';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    if (window.Sentry) window.Sentry.captureException(error, { extra: info });
    // eslint-disable-next-line no-console
    console.error('Caught by ErrorBoundary:', error, info);
  }
  reset = () => { this.setState({ error: null }); };
  render() {
    if (this.state.error) {
      return <ServerError lang={this.props.lang} error={this.state.error} onRetry={this.reset} />;
    }
    return this.props.children;
  }
}
